import InputField from '../../../../../component/form/FormInput';
import { useEffect, useState } from 'react';
import InputSelect from '../../../../../component/inputSelect/InputSelect';
import { toast } from 'react-toastify';
import Modal from '../../../../../component/modal/Modal';
import Button from '../../../../../component/ui/Button';
import { createDoctor, getDoctortypes } from '../../../../../services/doctors';
import { newObjectCreater } from '../../../../../utils/controller';

const AddDoctorModel = ({
	setIsAddDoctorModalOpen,
	isAddDoctorModalOpen,
	setDoctorList,
	setInvoice,
}) => {
	const [doctorDisplayNameList, setDoctorDisplayNameList] = useState([]);
	const [doctorTypeList, setDoctorTypeList] = useState([]);
	const [errors, setError] = useState({});
	const [isLoading, setLoading] = useState(false);
	const [doctor, setDoctor] = useState({
		doctor_type_id: null,
		doctor_name: '',
		business_name: '',
		doctor_display_name: '',
		doctor_email: '',
		doctor_phone_mobile: '',
		doctor_phone_work: '',
		registration_number: '',
	});

	async function getDoctorTypeList() {
		try {
			var { doctor } = await getDoctortypes();
			var doctorTypes = newObjectCreater(doctor?.types);
			setDoctorTypeList(doctorTypes);
		} catch (error) {
			toast.error(error);
		}
	}
	const validateEmail = (value) => {
		const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
		return regex.test(value);
	};

	const checkValidation = () => {
		var error = { ...errors };
		if (
			!doctor.registration_number ||
			doctor.registration_number === undefined ||
			doctor.registration_number === ''
		) {
			error.registration_number =
				'Please enter registration number(As Per State Medical Council) in the field';
		} else {
			delete error.registration_number;
		}
		if (!doctor.doctor_name || doctor.doctor_name === undefined || doctor.doctor_name === '') {
			error.doctor_name = 'Please enter doctor name in the field';
		} else {
			delete error.doctor_name;
		}
		if (
			!doctor.business_name ||
			doctor.business_name === undefined ||
			doctor.business_name === ''
		) {
			error.business_name = 'Please enter business name in the field';
		} else {
			delete error.business_name;
		}
		if (
			!doctor.doctor_display_name ||
			doctor.doctor_display_name === undefined ||
			doctor.doctor_display_name === ''
		) {
			error.doctor_display_name = 'Please select valid doctor display name in the list';
		} else {
			delete error.doctor_display_name;
		}
		if (Object.keys(error).length > 0) {
			setError(error);
			return true;
		} else {
			return false;
		}
	};

	async function handleAddDoctor() {
		const checkError = checkValidation();
		if (checkError) {
			toast.error('Please fill all mandatory fields before saving');
		} else {
			setLoading(true);
			const formData = new FormData();
			const doctorObj = {
				doctor_type_id: doctor.doctor_type_id,
				status: 1,
				name: doctor.doctor_name,
				display_name: doctor.doctor_display_name,
				business_name: doctor.business_name,
				email: doctor.doctor_email,
				phone: doctor.doctor_phone_work,
				mobile: doctor.doctor_phone_mobile,
				registration_number: doctor.registration_number,
			};
			for (const key in doctorObj) {
				formData.append(key, doctorObj[key]);
			}

			try {
				const res = await createDoctor(formData);
				if (res?.success) {
					setDoctorList([{ key: res?.data?.doctor?.id, value: doctor.doctor_name }]);
					setInvoice((prev) => ({
						...prev,
						doctor_id: res?.data?.doctor?.id,
					}));
					toast.success(res?.message);
					setIsAddDoctorModalOpen(false);
				} else {
					toast.error(res?.message || 'Something went wrong');
				}
			} catch (error) {
				toast.error(error?.message || 'Something went wrong');
			} finally {
				setLoading(false);
			}
		}
	}

	const handleDoctorDataChangeWithValidation = (key, value) => {
		setDoctor((prev) => ({
			...prev,
			[key]: value,
		}));

		var errorData = { ...errors };
		if (key === 'doctor_name' && (value === '' || value === undefined)) {
			errorData['doctor_name'] = 'Please enter doctor name in the field';
		} else {
			delete errorData['doctor_name'];
		}
		if (key === 'business_name' && (value === '' || value === undefined)) {
			errorData['business_name'] = 'Please enter business name in the field';
		} else {
			delete errorData['business_name'];
		}
		if (key === 'registration_number' && (value === '' || value === undefined)) {
			errorData['registration_number'] = 'Please enter registration number in the field';
		} else {
			delete errorData['registration_number'];
		}

		if (key === 'doctor_display_name' && (value === '' || value === undefined)) {
			errorData['doctor_display_name'] = 'Please select valid doctor display name in the list';
		} else {
			delete errorData['doctor_display_name'];
		}
		if (key === 'doctor_phone_work' || key === 'doctor_phone_mobile') {
			if (value) {
				if (value.length > 10 || value.length < 10) {
					errorData[key] =
						`Please enter valid ${key === 'doctor_phone_work' ? 'Phone Work' : 'Phone Mobile'} number`;
				} else {
					delete errorData[key];
				}
			} else {
				delete errorData[key];
			}
		}
		if (key === 'doctor_email') {
			if (value) {
				if (validateEmail(value)) {
					delete errorData['doctor_email'];
				} else {
					errorData['doctor_email'] = 'Please enter valid email address';
				}
			} else {
				delete errorData['doctor_email'];
			}
		}

		setError(errorData);
	};

	const handleDisplayDoctorNameList = () => {
		const data = [
			{ key: doctor.doctor_name, value: doctor.doctor_name },
			{ key: doctor.business_name, value: doctor.business_name },
		];
		setDoctorDisplayNameList(data);
	};

	useEffect(() => {
		getDoctorTypeList();
	}, []);

	useEffect(() => {
		handleDisplayDoctorNameList();
	}, [doctor.doctor_name, doctor.business_name]);

	return (
		<Modal
			className={'addDoctorModal'}
			title="Add Doctor"
			isOpen={isAddDoctorModalOpen}
			onClose={() => {
				setIsAddDoctorModalOpen(false);
			}}
			cancelButton={() => {
				setIsAddDoctorModalOpen(false);
			}}
		>
			<div>
				<div
					className="row"
					style={{ margin: '10px 0px' }}
				>
					<div className="col">
						<InputSelect
							options={doctorTypeList || []}
							placeholder="Select Doctor Type"
							label="Doctor Type"
							onChange={(value) => {
								if (value === null || value === '') {
									handleDoctorDataChangeWithValidation('doctor_type_id', value);
								}
							}}
							onSelect={(value) =>
								handleDoctorDataChangeWithValidation('doctor_type_id', value.key)
							}
							value={doctor.doctor_type_id}
							required={false}
							error={errors?.doctor_type_id}
							autoFocus={true}
						/>
					</div>
					<div className="col">
						<InputField
							label="Doctor Name"
							placeholder="Doctor Name"
							onChange={(value) => handleDoctorDataChangeWithValidation('doctor_name', value)}
							value={doctor.doctor_name}
							required={true}
							error={errors?.doctor_name}
						/>
					</div>
				</div>

				<div
					className="row"
					style={{ margin: '10px 0px' }}
				>
					<div className="col">
						<InputField
							label="Business Name"
							placeholder="Business Name"
							key="text"
							value={doctor.business_name}
							onChange={(value) => {
								handleDoctorDataChangeWithValidation('business_name', value);
							}}
							required={true}
							error={errors?.business_name}
						/>
					</div>
					<div className="col">
						<InputSelect
							options={doctorDisplayNameList || []}
							placeholder="Select Doctor Display Name"
							label="Doctor Display Name"
							onChange={(value) => {
								if (value === null || value === '') {
									handleDoctorDataChangeWithValidation('doctor_display_name', value.key);
								}
							}}
							onSelect={(value) =>
								handleDoctorDataChangeWithValidation('doctor_display_name', value.key)
							}
							value={doctor.doctor_display_name}
							required={true}
							error={errors?.doctor_display_name}
						/>
					</div>
				</div>
				<div
					className="row"
					style={{ margin: '10px 0px' }}
				>
					<div className="col">
						<InputField
							label="Registration Number (As Per State Medical Council)"
							placeholder="Registration Number"
							value={doctor.registration_number}
							onChange={(value) =>
								handleDoctorDataChangeWithValidation('registration_number', value)
							}
							type="text"
							required={true}
							error={errors?.registration_number}
						/>
					</div>

					<div className="col">
						<InputField
							label="Phone(Mobile)"
							placeholder="Mobile Number"
							key="text"
							maxLength={10}
							value={doctor.doctor_phone_mobile}
							onChange={(valueData) => {
								var value = valueData?.replace(/[^0-9]/g, '');
								handleDoctorDataChangeWithValidation('doctor_phone_mobile', value);
							}}
							error={errors.doctor_phone_mobile}
						/>
					</div>
				</div>
				<div
					className="row"
					style={{ margin: '10px 0px' }}
				>
					<div className="col">
						<InputField
							label="Email"
							placeholder="Email"
							value={doctor.doctor_email}
							onChange={(value) => handleDoctorDataChangeWithValidation('doctor_email', value)}
							key="text"
							error={errors.doctor_email}
						/>
					</div>

					<div className="col">
						<InputField
							label="Phone(Work)"
							placeholder="Phone(Work)"
							maxLength={10}
							value={doctor.doctor_phone_work}
							onChange={(valueData) => {
								var value = valueData?.replace(/[^0-9]/g, '');
								handleDoctorDataChangeWithValidation('doctor_phone_work', value);
							}}
							key="text"
							error={errors.doctor_phone_work}
						/>
					</div>
				</div>
				<div
					style={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'end',
						gap: 12,
						marginTop: '10px',
					}}
				>
					<Button
						type="button"
						className="mt-0 btn-primary add-pro"
						button="Save"
						loader={isLoading}
						onClick={() => handleAddDoctor()}
					/>
					<Button
						type="button"
						className="mt-0 btn-gray add-pro"
						button="Cancel"
						onClick={() => setIsAddDoctorModalOpen(false)}
					/>
				</div>
			</div>
		</Modal>
	);
};

export default AddDoctorModel;
